import React from 'react';
import { Star, ShieldCheck, MapPin, Users } from 'lucide-react';
import { useBoltMod } from '../utils/boltMod';

const ITEMS = [
  { icon: Star,        text: '4.9 Google értékelés',   sub: '500+ vélemény',        className: 'text-yellow-500' },
  { icon: Users,       text: 'Több száz elégedett',    sub: 'orosházi ügyfél',       className: 'text-brand' },
  // A "javítási" a főszövegben van, mert mobilon a sub rejtett – a felvásárlás-
  // oldalon így is egyértelmű, hogy a garancia a szervizmunkára vonatkozik.
  { icon: ShieldCheck, text: '6 hónap javítási garancia', sub: 'minden szervizmunkára', className: 'text-brand' },
  { icon: MapPin,      text: '2 üzlet Orosházán',      sub: 'személyes ügyintézés',  className: 'text-brand' },
];

// Bolt mód (szerviz-mentes hirdetési változat): a javítási garancia helyett a
// használt készülékek garanciája.
const BOLT_GARANCIA = { icon: ShieldCheck, text: '3 hónap garancia', sub: 'minden eladott használt telefonra', className: 'text-brand' };

export default function SocialProofStrip({ className = '' }) {
  const bolt = useBoltMod();
  const items = bolt ? ITEMS.map((it, i) => (i === 2 ? BOLT_GARANCIA : it)) : ITEMS;
  return (
    <div className={`bg-white border-y border-gray-100 ${className}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3">
        <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-2">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-2">
              <item.icon size={15} className={item.className} />
              <span className="text-sm font-semibold text-ink">{item.text}</span>
              <span className="text-xs text-gray-500 hidden sm:inline">{item.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
